import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_FAC019_Request,
  IAPI_FAC019_Response,
  IAPI_STA025_Request,
  IAPI_STA025_Response,
  IAPI_STA032_Request,
  IAPI_STA032_Response,
} from "../../../type/apiType";

// プルダウン用有効施設一覧参照
const httpAPI_FAC019 = async (
  param: IAPI_FAC019_Request
): Promise<IAPI_FAC019_Response> => {
  let res = await http.post(ApiUrl.API_FAC019, {
    ...param,
  });

  return res.data;
};

// 従業状況更新参照
const httpAPI_STA025 = async (
  param: IAPI_STA025_Request
): Promise<IAPI_STA025_Response> => {
  let res = await http.post(ApiUrl.API_STA025, {
    ...param,
  });

  return res.data;
};

// 日々更新法人職員系TBLの更新
const httpAPI_STA032 = async (
  param: IAPI_STA032_Request
): Promise<IAPI_STA032_Response> => {
  let res = await http.post(ApiUrl.API_STA032, {
    ...param,
  });

  return res.data;
};

export { httpAPI_FAC019, httpAPI_STA025, httpAPI_STA032 };
